/*
 * @ProjectName: Union Service
 * @FileName:
 * @PackageName:
 * @Author: zhang lei
 * @Date: 2021-06-04 13:56:13
 * @LastEditTime: 2021-06-04 13:56:52
 * @LastEditors: zhang lei
 * @Description:
 * @FilePath: /desktop/src/store/modules/union.js
 * @copyright(c) 2017-2020 BMW Brilliance Automotive Co., Ltd.
 */
import {
  getwelfareData,
  shelfWelfare,
  patchWelfare,
  deleteWelfare,
  postWelfare,
  getWelfareInfo,
  getwelfareUserData,
  getImage,
  deleteWelfareUser,
  downloadTem,
  downloadAll,
  uploadFile
} from "@/service/welfareService";
const welfare = {
  state: {},
  mutations: {},
  getters: {},
  actions: {
    /**
     * 福利列表页接口
     */
    getwelfareData(store, info) {
      return new Promise((resolve, reject) => {
        getwelfareData(info)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 上架福利接口
     */
    shelfWelfare(store, info) {
      return new Promise((resolve, reject) => {
        shelfWelfare(info)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 新建福利接口
     */
    postWelfare(store, info) {
      return new Promise((resolve, reject) => {
        postWelfare(info)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 编辑福利接口
     * @param {*} store
     * @param {*} info
     * @returns
     */
    patchWelfare(store, info) {
      return new Promise((resolve, reject) => {
        patchWelfare(info)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 删除福利接口
     * @param {*} store
     * @param {*} info
     * @returns
     */
    deleteWelfare(store, info) {
      return new Promise((resolve, reject) => {
        deleteWelfare(info)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 获取福利详情
     * @param {*} store
     * @param {*} info
     * @returns
     */
    getWelfareInfo(store, info) {
      return new Promise((resolve, reject) => {
        getWelfareInfo(info)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 福利人员列表
     * @param {*} store
     * @param {*} info
     * @returns
     */
    getwelfareUserData(store, info) {
      return new Promise((resolve, reject) => {
        getwelfareUserData(info)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 获取图片地址
     */
    getImage(store, info) {
      return new Promise((resolve, reject) => {
        getImage(info)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 删除福利user
     */
    deleteWelfareUser(store, info) {
      return new Promise((resolve, reject) => {
        deleteWelfareUser(info)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 下载模板
     */
    downloadTem(store, info) {
      return new Promise((resolve, reject) => {
        downloadTem(info)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 下载全部
     */
    downloadAll(store, info) {
      return new Promise((resolve, reject) => {
        downloadAll(info)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 导入文件
     */
    uploadFile(store, info) {
      return new Promise((resolve, reject) => {
        uploadFile(info)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};
export default welfare;



// WEBPACK FOOTER //
// ./src/store/modules/welfare.js